import { render, staticRenderFns } from "./DisplayKindSO.vue?vue&type=template&id=07f9aa78&scoped=true&"
import script from "./DisplayKindSO.vue?vue&type=script&lang=js&"
export * from "./DisplayKindSO.vue?vue&type=script&lang=js&"
import style0 from "./DisplayKindSO.vue?vue&type=style&index=0&id=07f9aa78&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f9aa78",
  null
  
)

export default component.exports